import { useEffect, useRef, useState } from "react";
import { ReactComponent as PlusIcon } from "../../Assets/icons/plus.svg";
import { ReactComponent as MinusIcon } from "../../Assets/icons/minus.svg";
import clsx from "clsx";

const FaqItem = ({ question, answer, activeFaq, setActiveFaq, index }) => {
  const [isOpen, setIsOpen] = useState(false);

  const contentEl = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
    setActiveFaq(index);
  };

  useEffect(() => {
    if (activeFaq !== index) setIsOpen(false);
  }, [activeFaq]);

  return (
    <div
      className={clsx("mb-[2.8rem] border-b-[#0A265F] border-b-2 w-full", {
        // ['border-b-[#0A265F] border-b-2']: !isOpen,
      })}
    >
      <button
        className="flex justify-between items-center w-full pb-[3.2rem] text-left focus:outline-none "
        onClick={toggleAccordion}
      >
        <span className="font-[600] text-[13.56px] md:text-[3.972rem] text-[#0A265F] flex-1">
          {question}
        </span>
        <span
          className={clsx(
            `rounded-full mr-[3rem] border border-[#0A265F] md:mr-[6rem] flex items-center justify-center w-[5.509rem] h-[5.509rem] ${
              isOpen ? "bg-[#0A265F]" : "bg-white"
            } ${isOpen ? "text-white/[1]" : "text-[#0A265F]"}`,
            {
              "border border-[#0A265F]": !isOpen,
            }
          )}
        >
          {isOpen ? (
            <MinusIcon width={"1.789rem"} height={"1.789rem"} />
          ) : (
            <PlusIcon width={"1.789rem"} height={"1.789rem"} />
          )}
        </span>
      </button>

      <div
        ref={contentEl}
        style={
          isOpen
            ? { height: contentEl.current && contentEl.current.scrollHeight }
            : { height: "0px" }
        }
        className="duration-300 transition-all overflow-hidden"
      >
        <p className="text-[#0A265F] text-[11.3px] md:text-[3.31rem] leading-[4rem] mb-[4rem]">
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: answer }}
          ></div>
        </p>
      </div>
    </div>
  );
};

const FAQ = ({faqData}) => {
  const [activeFaq, setActiveFaq] = useState(0);

  return (
    <div id="faq" className="pt-[4.2rem] pb-[8.3rem] bg-[#FCFCFC]">
      <div className="container">
        <h2 className="text-[7.404rem] text-center font-[700] text-[#0A265F]">
          FAQs
        </h2>
        <div className="flex flex-col justify-center items-center mt-[3.2rem]">
          {faqData.map((item, index) => (
            <FaqItem
              key={index}
              question={item.question}
              answer={item.answer}
              setActiveFaq={setActiveFaq}
              activeFaq={activeFaq}
              index={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
